import { API, authClient } from "../index";

// Get all features
export const getAllActiveFeatures = () => {
    return authClient().get(`${API}/feature/`);
};

// Get feature by id
export const getFeatureById = (id) => {
    return authClient().get(`${API}/feature/${id}`);
};

// Delete feature
export const deleteFeature = (id) => {
    return authClient().delete(`${API}/feature/${id}`);
};

// Create feature
export const postFeature = async (feature) => {
    return authClient().post(`${API}/feature`, feature);
};

// Update feature
export const updateFeature = async (id, feature) => {
    return authClient().put(`${API}/feature/${id}`, feature);
};